import { TDefaultPermission, TPermissionData } from "./interface";

export const extractDefaultPermissions = (permissions: TPermissionData[]): TDefaultPermission[] => {
    const result: TDefaultPermission[] = [];
  
    const traverse = (items: TPermissionData[]) => {
      for (const item of items) {
        const { id, module_name, parent_permission_id, perm_code } = item;
        result.push({ id, module_name, parent_permission_id, perm_code });
  
        if (item.child?.length) {
          traverse(item.child);
        }
      }
    };
  
    traverse(permissions);
    return result;
  };
  